function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, useSortable, arrayMove } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function WrappedSortableContext(props) {
  function handleDragEnd(event) {
    const {
      active,
      over
    } = event;

    if (active.id !== over.id) {
      // Back from string to int
      props.onDrop({
        source: parseInt(active.id),
        target: parseInt(over.id)
      });
    }
  } // Index as strings


  return /*#__PURE__*/React.createElement(DndContext, {
    collisionDetection: closestCenter,
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React.createElement(SortableContext, {
    items: props.items.map(i => i.toString())
  }, props.children));
}

function WrappedSortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = // Index as strings
  useSortable({
    id: props.id.toString(),
    transition: null // null,
    // {
    // 	duration: 500,
    // 	easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    // },

  });
  const style = {
    transform: CSS.Transform.toString(transform),
    // transition is broken?
    // - think it's because concur is re-rendering() after events... maybe need a signal or something?
    //
    transition
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: setNodeRef,
    style: style
  }, attributes, listeners), props.children);
}

export const _wrappedSortableContext = WrappedSortableContext;
export const _wrappedSortableItem = WrappedSortableItem;